import localFont from 'next/font/local'

const NexaFont = localFont({
	src: [
		{ path: './light.woff2', weight: '300', style: 'normal' },
		{ path: './bold.woff2', weight: '700', style: 'normal' }
	],
	display: 'swap'
})

export default NexaFont
